'use client';

import { Box, Button } from "@mui/material";
import { MediaBrowserV2Dialog } from "@/app/features/shared/media-browser-v2";
import { useState } from "react";
import { UploadFile } from "@/app/lib/generated/graphql-types";
import { Collections } from "@mui/icons-material";
import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";

interface EditMediaButtonOverlayProps {
    onImageChange?: (image: MediaRef | null) => void;
    align?: 'left' | 'center' | 'right';
    layout?: 'overlay' | 'inline';
}

export default function EditMediaButtonOverlay({
    onImageChange,
    align = 'center',
    layout = 'overlay',
}: EditMediaButtonOverlayProps) {

    const [isMediaBrowserOpen, setIsMediaBrowserOpen] = useState(false);
    const isInline = layout === 'inline';

    function handleOnApply(image: UploadFile | null) {
        onImageChange?.(image)
        setIsMediaBrowserOpen(false)
    }

    return (
        <>
            <Box
                sx={{
                    position: isInline ? 'static' : 'absolute',
                    top: isInline ? undefined : '50%',
                    zIndex: '1000',
                    transform: isInline ? 'none' : 'translate(50%, -50%)',
                    right: isInline
                        ? undefined
                        : align === 'left'
                            ? '75svw'
                            : align === 'right'
                                ? '25svw'
                                : '50%',
                    display: isInline ? 'flex' : undefined,
                    justifyContent: isInline ? 'center' : undefined,
                    transition: (theme) =>
                        theme.transitions.create(isInline ? ['opacity'] : ['right', 'transform', 'opacity'], {
                            duration: theme.transitions.duration.standard,
                            easing: theme.transitions.easing.easeInOut,
                        }),
                    willChange: isInline ? 'opacity' : 'right, transform, opacity',
                    '@media (prefers-reduced-motion: reduce)': {
                        transition: 'none',
                    },
                }}
            >
                <Button
                    startIcon={<Collections />}
                    variant="contained"
                    color="breakout"
                    size="small"
                    onClick={() => setIsMediaBrowserOpen(true)}
                    sx={{
                        transition: (theme) =>
                            theme.transitions.create(['box-shadow', 'transform'], {
                                duration: theme.transitions.duration.shorter,
                                easing: theme.transitions.easing.easeInOut,
                            }),
                        '&:hover': {
                            transform: 'translateY(-1px)',
                        },
                        '@media (prefers-reduced-motion: reduce)': {
                            transition: 'none',
                            '&:hover': { transform: 'none' },
                        },
                    }}
                >
                    Bild ändern
                </Button>
            </Box>
            <MediaBrowserV2Dialog
                isOpen={isMediaBrowserOpen}
                onApply={handleOnApply}
                onClose={() => setIsMediaBrowserOpen(false)}
            />
        </>
    )
}
